class LocalStorageStrategy {
    getKey(scenario) {
        return `app-content-admin:not-show-again:${scenario}`;
    }
    get(scenario) {
        return Promise.resolve(localStorage.getItem(this.getKey(scenario)) === 'true');
    }
    set(scenario, value) {
        if (value) {
            localStorage.setItem(this.getKey(scenario), 'true');
        }
        else {
            localStorage.removeItem(this.getKey(scenario));
        }
        return Promise.resolve();
    }
}
export const localStorageStrategy = new LocalStorageStrategy();
